export default __webpack_public_path__ + "static/media/Ellipse 20.976152c5.png";